<template>
  <div :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <div
      class="scroll-to"
      style="position: absolute; top: 0; left: 0; margin: 0; padding: 0"
      id="scroll_to"
    ></div>
    <div class="background" style="z-index: -2"></div>

    <!-- <nav>
    <div class="flex-center">
      <div class="left-side">
        <router-link
          class="nav-item"
          to="/favourite"
          v-if="$store.state.token != ''"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m12.1 18.55l-.1.1l-.11-.1C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5c1.54 0 3.04 1 3.57 2.36h1.86C13.46 6 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5c0 2.89-3.14 5.74-7.9 10.05M16.5 3c-1.74 0-3.41.81-4.5 2.08C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.41 2 8.5c0 3.77 3.4 6.86 8.55 11.53L12 21.35l1.45-1.32C18.6 15.36 22 12.27 22 8.5C22 5.41 19.58 3 16.5 3"
            />
          </svg>
        </router-link>
      </div>
    </div>
  </nav> -->
    <nav class="navbar navbar-expand-lg fixed-top p-3">
      <div class="container-fluid">
        <router-link class="nav-item" to="/">
          <img :src="logo_src" style="background-color: whitesmoke" alt="" />
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <div class="flex-center">
            <div class="right-side">
              <!-- <ul class="navbar-nav me-auto mb-2 mb-lg-0"> -->
              <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item">
                  <router-link class="nav-link" to="/">{{
                    $t("Navbar.Home")
                  }}</router-link>
                </li>
                <!-- <li class="nav-item">
                <router-link class="nav-link" to="/message-vison"
                  >كلمة الرئيس التنفيذي والرؤية</router-link
                >
              </li>
              <li class="nav-item dropdown">
                <button
                  class="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  بروفايل أصول بلس
                </button>
                <ul class="dropdown-menu bg-dark">
                  <li>
                    <router-link
                      to="/about-us?id=who_we_are"
                      class="dropdown-item"
                      >تعريف</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about-us?id=message" class="dropdown-item"
                      >كلمة الرئيس التنفيذي</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about-us?id=letter" class="dropdown-item"
                      >الرؤية</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/about-us?id=strategy"
                      class="dropdown-item"
                      >استراتيجية المصنع</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about-us?id=welcome" class="dropdown-item"
                      >الترحيب</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about-us?id=team" class="dropdown-item"
                      >فريقنا</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about-us?id=team" class="dropdown-item"
                      >ديكورات وقطع خشبية</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about-us?id=offices" class="dropdown-item"
                      >مكاتب حديثة</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/about-us?id=projects"
                      class="dropdown-item"
                      >مشاريعنا</router-link
                    >
                  </li>
                </ul>
              </li> -->

                <li class="nav-item">
                  <router-link class="nav-link" to="/news">{{
                    $t("Navbar.News")
                  }}</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/projects">{{
                    $t("Navbar.Projects")
                  }}</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/our-team">{{
                    $t("Navbar.team")
                  }}</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/make-appointment">{{
                    $t("Navbar.ContactUs")
                  }}</router-link>
                </li>
              </ul>
            </div>
            <div class="left-side">
              <div class="nav-item dropdown">
                <button
                  class="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    v-if="$i18n.locale === 'ar'"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32px"
                    height="24px"
                    viewBox="0 0 640 480"
                  >
                    <defs>
                      <clipPath id="flagSa4x30">
                        <path
                          fill-opacity="0.7"
                          d="M-85.3 0h682.6v512H-85.3z"
                        />
                      </clipPath>
                    </defs>
                    <g
                      fill-rule="evenodd"
                      clip-path="url(#flagSa4x30)"
                      transform="translate(80)scale(.9375)"
                    >
                      <path fill="#165d31" d="M-128 0h768v512h-768z" />
                      <path
                        fill="#fff"
                        d="M65.5 145.1c-.8 12-2 33 8.3 35.2c12.3 1.2 5.5-20.8 10-24.8c.8-2 2.3-2 2.4.5v18.7c0 6 4 7.8 7 9c3.2-.2 5.4 0 6.6 3l1.6 32.3s7.4 2.2 7.8-18.1c.3-12-2.4-21.9-.8-24.2c0-2.3 3-2.4 5-1.3c3.2 2.2 4.6 5 9.6 4c7.6-2.2 12.2-5.9 12.3-11.7a47 47 0 0 0-3.5-16.6c.4-1-1.4-3.7-1-4.7c1.3 2.2 3.4 2 3.8 0c-1.3-4.2-3.3-8.3-6.5-10c-2.7-2.4-6.7-2-8 3c-.8 5.7 2 12.4 6.1 18c.9 2.1 2.1 5.7 1.6 8.9c-2.2 1.3-4.4.7-6.3-1.2c0 0-6-4.5-6-5.6c1.6-10.2.3-11.4-.6-14.3c-.6-3.9-2.5-5.2-4-7.8c-1.5-1.6-3.5-1.6-4.5 0c-2.7 4.6-1.4 14.5.5 19c1.4 4.1 3.5 6.7 2.5 6.7c-.8 2.3-2.5 1.7-3.8-1a66.6 66.6 0 0 1-2.1-17.4c-.5-4.6-1.1-14.4-4.2-17c-1.8-2.4-4.5-1.2-5.5 1a82.4 82.4 0 0 0 .3 13.4c2 7.4 2.7 14 3.7 21.5c.3 10.1-5.8 4.4-5.5-.7a45 45 0 0 0-.3-19.4c-1-2.6-2.1-3.2-4.6-2.8c-1.9 0-6.8 5.3-8.2 14.3c0 0-1.2 4.6-1.7 8.7c-.7 4.6-3.7 8-5.9-.6c-1.8-6.3-3-21.6-6-18z"
                      />
                      <path
                        fill="#fff"
                        d="m99 194.2l-32 15.4c.3-7.3 15.1-20.4 25.3-20.5c6.5.1 4.9 2.5 6.6 5.1z"
                      />
                      <path
                        fill="#fff"
                        d="M93.3 204.2c-16.8 43.5 39.5 49.6 45.8 1.8c.6-2 3-3.9 3.4-.7c-1.3 43.3-43.6 46.2-50.8 32.6a41.9 41.9 0 0 1-2.5-14.6c-1-8.5-5.5-5.2-6.2 3.2c-.7 4.7-.5 6-.5 10.5c2.2 34.2 56.7 19.5 65.6-8.7c4.7-15.6-.8-27.1 1.7-27.1c5.4 5.8 13 .8 14.7-1.2c.7-1 2.5-1.7 3.7-.4c4.2 3 11.6 1.6 13.2-3.7c.9-5.3 1.6-10.7 1.8-16.2c-3.5 1-6 1.7-6.3 3.2l-.7 4.6c-.3 1.5-3.2 1.5-3.4-.4c-1.3-6-6.7-6.7-10 2.5c-2.1 1.8-6.1 2.2-6.5-.5c.5-6.2-2-7-7-4.1l-4.8-36.2c2 0 4 1.5 5.9-.9c-2-6.5-6.5-19.7-9-20.7c-1.1-1.4-2.1-.5-3.7-.1c-2.6.8-5 3-4.2 7.4c3 18.8 5 33.1 8.1 52c.5 2.1-1.3 5-3.7 4.7c-4-2.7-5-8.2-12-8c-5 0-10.6 5.5-11.3 10.7c-.9 4.2-1.2 8.7 0 12.3c3.5 4.2 7.7 3.8 11.4 2.9c3-1.3 5.5-4.3 6.6-3.6c.7.9.1 10.9-14.3 18.5c-8.7 4-15.7 4.8-19.4-2.3c-2.3-4.5.2-21.4-5.6-17.5"
                      />
                      <path
                        fill="#fff"
                        d="M165 160c3.3-1.2 19.3-19.6 19.3-19.6l-2.4-2c-.9-.7-.8-1.5 0-2.2c4-2.4 2.7-7.4.7-9.8a9.7 9.7 0 0 0-8.7.1c-2.8 2.7-3.4 7-1.2 9.6c2.1 1 4.2 3.2 2.8 4.4c-6.6 7-24.5 19.1-22.4 19.5c.4.6 11.5.6 11.8 0zm-97 65c-6 9.6-6.5 23.9-3.2 28.2c1.8 2 4.7 2.9 6.8 2.2c3.8-1.6 5.5-9.3 4.6-12c-1.3-2-2.3-2.3-3.6-.7c-2.6 5.4-3.7 1.7-4-1.3a70 70 0 0 1 .8-15.2c.7-4.2 0-3-1.4-1.2m257.1-15.3c-5.8-12.6-13.9-25-16.4-29.7a558 558 0 0 0-24.8-36c-6.2-7.4 10.2 3.1-2-11.7l-8.9-7.5c-2-1.4-6.8-4-7.6.2c-.4 3.8-.2 5.8.4 8.9c.5 2 3.5 5.5 5 7.5a565 565 0 0 1 53.8 86.5c2.6-1.3 2-16.1.5-18.2"
                      />
                      <path
                        fill="#fff"
                        d="M299.6 251.5c-1.2 1.3 2.8 6.8 8 6.8c8.6-1 16.2-5.8 23.2-18.6a33 33 0 0 0 5.3-14.2a317 317 0 0 0-5.8-72.4c-.3-2 0-4.4.2-5c.6-.7 2.5 0 3.5-1.7c1.5-1.5-4-14-7-18.7c-1-2.2-1.5-3.6-3.3.2a27 27 0 0 0-3 13.6c4.1 28.5 5.4 53.4 8 81.9c.3 2.8-.1 6.8-2 8.4a80.2 80.2 0 0 1-27.1 19.7m116.5-.1c-6.2 3.6-6.2 7.7-1.2 7.8c8.6-1 18.8-1.7 25.8-12.3a41 41 0 0 0 4.2-16a303 303 0 0 0-4.7-71.4c-.2-2-1.1-6.7-.8-7.3c.6-1.4 3.4.1 4.4-1.5c1.4-1.5-7.3-12.7-10.4-17.5c-1-2.2-1.4-3.6-3.3.2a22.3 22.3 0 0 0-1.8 13.6c4.6 31 8 54.2 8.7 81.6c-.4 2.6-.5 4-1.7 7.3c-2.7 3.4-5.7 7.8-8.5 9.9c-2.8 2-8.8 4-10.7 5.6"
                      />
                      <path
                        fill="#fff"
                        d="M420.7 223.7c0-7.3.1-13.5-.1-19a34 34 0 0 0-3-13.5c-1.8-4.1-.7-7.4-1.6-11.8c-.8-4.4-.6-11-1.8-16.1c-.4-2-1.4-8.5-1.1-9.2c.5-1.4 2.4 0 3.4-1.6c1.4-1.5-5-18-8.2-22.7c-1.1-2.1-3.3-1.4-5.8 2c-2.5 2.3-1.6 7.4-.6 12.3c6.1 32.3 10.8 61.6 9.8 92.3c-.4 2.6 9-7.8 9-12.7m-45.7-40c-3.9-.2-12-7.7-14.4-12a8 8 0 0 1 .4-6.5c1.5-1 3.7-2 5.4-1c0 0 1.7 2.4 1.4 2.7c2 1 3 .5 3.2-.4c.1-1.5-.6-2.4-.6-4c.9-4.6 6-5.3 8-2.4c1.4 1.8 2 5.5 2.1 8c0 1.3-2-.2-3.3 0c-1.1.4-1.4 1.8-1.5 3c-.2 3.3-.6 8.6-.7 12.5zm-71.8 48c1-9.8-.4-27.3-.5-33.1A477 477 0 0 0 299 154c-1.2-8.4 3.4.9 2.8-4c-1.5-8.3-6.1-14-11.6-21.5c-1.7-2.5-1.7-3-4.4.6c-3 6.7-.4 11.4.4 16.7c3.9 17.2 6.2 33 7.3 48.7a393 393 0 0 1 .4 49c3 .1 7.6-4.7 9.3-11.8"
                      />
                      <path
                        fill="#fff"
                        d="M434 216c-6.9-11.6-17.2-24-20-28.7a658 658 0 0 0-29.2-37.8c-8.5-9 4-1.5-1.6-8.5c-4.7-5.1-6-6.8-10.1-9.9c-2-1.3-3.2-3.8-4 .5a83 83 0 0 0-.2 11.2c0 1.7 1.8 5 3.4 7c20.7 25.5 43.4 51.5 61.6 84.2c2.6-1.3 1.7-16 0-18z"
                      />
                      <path
                        fill="#165d31"
                        d="M122.6 194.7c-.5.9-1.6 2-1.2 3.1c.7 1 1.4 1.3 2.6 1.3c1.1 0 2.7.3 3-.3c.6-.7 1-2 .6-3.3c-1.2-3-4.4-1.8-5-.8"
                      />
                      <path
                        fill="#fff"
                        d="M354.2 362.5c9.2.4 15.2.5 23.3 1.4l9.6-1c10.6-1 11 15.1 11 15.1c0 9.5-3.7 10-8.4 11c-2.7.4-4-1.6-5.5-3.6a14 14 0 0 1-7 .4c-3.9-.2-7.7-.2-11.5-.5c-4-.3-6.2.5-10.3.1c-.8 1.3-2 3.1-4.4 2.6c-2-.3-4.5-6-3.8-10.5c1.5-3.2 1-2.1 1-3.5c-37.6-1-75.5-2.7-112.3-2.2c-28.8.1-57.2 1.3-85.7 2.5c-15.2-.2-26.8-2.6-34.8-14.3c.8 0 38.8 2.1 49.9 1.4c20.5-.2 39.3-1.9 60.2-2.5c41.2.7 82.1.7 123.3 3.6c-4-2.7-4-9 2-10.6c.5-.4.8 3.1 1.7 3c4.9-.3 2.7 6.3 1.7 7.6M188.6 135.3c-6.2 17.8 3.6 37.4 10.4 35.5c5 2 8-7.4 10-17.6c1.5-2.9 2.5-3.2 3.2-1.7c-.2 13.6 1 16.7 4.5 20.8c7.8 6 14.3.8 14.8.3l6-6.1c1.4-1.5 3.2-1.5 5.1-.3c1.9 1.7 1.6 4.6 5.6 6.6c3.4 1.4 10.5.4 12.2-2.5c2.2-3.9 2.8-5.2 3.8-6.6c1.6-2.1 4.3-1.2 4.3-.5c-.3 1.2-1.9 2.3-.8 4.5c2 1.4 2.4.5 3.5.2c4-2 7-10.6 7-10.6c.1-3.2-1.7-3-2.9-2.2l-3.1 2.1c-2 .3-5.7 1.6-7.6-1.3c-1.9-3.4-1.9-8.3-3.3-11.8c0-.2-2.6-5.5-.2-5.8c1.2.2 3.7.9 4.1-1.2c1.2-2.1-2.6-8-5.3-11c-2.3-2.5-5.5-2.8-8.6-.2c-2.2 2-1.9 4.2-2.3 6.3a9.8 9.8 0 0 0 2 8.7c2.2 4.2 6.1 9.7 4.8 17.5c0 0-2.3 3.6-6.3 3.1c-1.7-.3-4.4-1-5.8-11.8c-1.1-8 .2-19.4-3.2-24.7c-1.3-3.3-2.2-6.4-5.2-.9c-.8 2.2-4.3 5.5-1.8 12.2a36 36 0 0 1 2 19c-1.5 2.2-1.8 2.9-3.7 5c-2.6 3-5.5 2.2-7.7 1.1c-2-1.3-3.6-2-4.6-6.5c.2-7 .6-18.5-.7-20.9c-1.9-3.8-5-2.4-6.3-1.2a47.7 47.7 0 0 0-11.5 23.5c-1.8 5.8-3.7 4.1-5 1.8c-3.2-3-3.5-26.7-7.4-22.8"
                      />
                      <path
                        fill="#fff"
                        d="M207.4 174.1c2.9-2 1.6-3.4 5.8.8a72 72 0 0 1 9.2 31.3c-.2 2.6 1.6 4.2 2.5 3.6c.4-6 15.1-14.4 28.6-15.6c2-.5 1-4.4 1.3-6.4c-.8-7.5 4.2-14.3 11.2-14.8c9.6 1.4 12.8 6.5 13 14.2c-1.1 15-16.7 17.5-25.4 18.7c-1.3.5-1.9 1.1 0 1.8l36.6.2l1.9 1c.2 1-.6.2-2 2.6a29.5 29.5 0 0 0-3.7 11.5c-10.9 3.6-22.2 5-33.6 6.5c-4 2-6 4.7-5.2 7.7c1.4 3.3 10.2 6.7 10.2 6.8c1.7 1 3.6 3.5-.5 8.6c-17.8-.8-31.7-8.4-36.5-19.1c-1.4-1.1-3 0-4 1.4c-7 9-13.8 17-25.7 21.4c-7 1.8-14.3-1.1-17.7-5.7c-2.3-2.7-2.2-5.6-3-6.2c-3.9 1.7-36.9 15.7-32.7 9.1c8-8.5 22-14.9 34.2-23.3c.9-2.9 2.5-12.5 7.3-15.6c.3 0-.7 5.6-.6 8c0 2-.2 2.7.2 2.2c.9-.5 15.7-12.2 17-15.8c1.4-2 .3-7.2.3-7.4c-2.8-7.2-6.7-7.8-8.1-11.4c-1.3-4.7-.7-10.1 2-11.7c2.4-2.1 5.2-1.9 7.9.5c3 2.7 5.6 8 6.4 11.9c-.5 1.5-4-1-5-.3a16 16 0 0 1 3.7 7.8c2 8.2 1.4 11.4-.6 16.7c-6.6 13.9-15 18-22.4 23.2c-.2 0-.3 3.5 2.4 5.4c1 1 4.9 1.5 9.4 0a54.5 54.5 0 0 0 22.3-23.3a51 51 0 0 0-2.4-22.2c-2.9-6.7-6.3-16.2-6.3-16.4c-.1-4.2.2-5.6 2-7.7m-95.8-38.6c4.2 2 12.2 1.1 11.8-5.7l-.2-3.1c-.8-2-3.2-1.5-3.7.5c-.2.7.3 1.8-.3 2.1c-.4.4-1.7.2-1.7-1.7c0-.6-.4-1.2-.7-1.6c-.2-.2-.4-.2-.9-.2c-.6 0-.6.1-.9.6c-.1.5-.3 1-.3 1.6c0 .7-.4.9-.8 1c-.6 0-.5 0-1-.2c-.2-.3-.5-.4-.5-1l-.3-1.6c-.2-.3-.6-.5-1-.6c-2.3 0-2.5 2.7-2.3 3.7c-.2.2-.3 4.9 2.8 6.2"
                      />
                      <path
                        fill="#fff"
                        d="M235.1 187.7c4.2 2 14.3.9 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.6c-.2.6.3 1.7-.4 2c-.3.4-1.7.2-1.6-1.6c0-.6-.4-1.3-.7-1.7c-.3-.1-.4-.2-1-.2c-.5 0-.5.2-.8.7c-.2.5-.3 1-.3 1.6c-.1.6-.4.8-.9 1c-.5 0-.4 0-.8-.3c-.3-.3-.6-.4-.6-.9l-.3-1.6c-.2-.3-.6-.5-1-.6c-2.3 0-2.5 2.6-2.4 3.6c-.1.2-.2 5 3 6.2zm72-21.6c4.2 2 12.1 1.1 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.5c-.2.7.3 1.8-.4 2.2c-.3.3-1.7.1-1.6-1.8c0-.6-.4-1.2-.7-1.6c-.3-.2-.4-.2-1-.2c-.5 0-.5.2-.8.7l-.3 1.5c-.1.7-.4 1-.9 1s-.4 0-.8-.2c-.3-.3-.6-.4-.6-.9s-.1-1.3-.3-1.7c-.2-.3-.6-.4-1-.5c-2.3 0-2.5 2.6-2.4 3.6c-.1.2-.2 4.9 3 6.2zm37.3 54.3c-7.3 8.3-4.1 22-2.4 25c2.4 4.8 4.3 7.9 9 10.3c4.3 3.1 7.7 1.2 9.5-1c4.3-4.5 4.4-16 6.4-18.2c1.4-4.2 5-3.5 6.7-1.6a16.5 16.5 0 0 0 6.2 5.3c4 3.5 8.8 4.2 13.6 1c3.2-1.9 5.3-4.2 7.2-8.9c2-5.6 1-31.6.5-47l-4.2-21.5c0-.2-.5-10.2-1-12.5c0-1-.3-1.3.7-1.2c1.1 1 1.2 1 2 1.3c1 .2 2-1.7 1.3-3.3l-10-18.6c-.8-.8-1.9-1.6-3.2.2a7.3 7.3 0 0 0-2.4 5.5c.3 4.4 1 8.9 1.3 13.3l4 22.6c1.3 16 1.6 29.2 2.9 45.3c-.2 6.8-2.3 12.7-4.3 13.6c0 0-3 1.7-5-.2c-1.5-.6-7.4-9.9-7.4-9.9c-3-2.7-5-2-7.1 0c-6 5.8-8.6 16.4-12.7 23.8c-1 1.7-4 3-7.2-.1c-8.2-11.3-3.4-27.3-4.4-23.2M309 126.7c3.8 1.5 6.4 9.2 5.6 13c-.8 4.5-2.8 9.5-4.2 8.9c-1.6-.6 1-4.6-.5-8.8c-.8-2.8-6-7.8-5.4-9.2c-1-3.1 2.2-4.5 4.5-4z"
                      />
                      <path
                        fill="#fff"
                        d="M356.6 225c.7-9.2-.6-14.8-.8-20.2s-6.1-46.6-7.3-50.6c-1.5-7.8 5.7-1 4.9-5.6c-2.5-5.6-8.6-13.9-10.5-18.8c-1.2-2-.7-4-3.3-.5a42.3 42.3 0 0 0-2.3 19.2c6.2 32.3 12.5 59.1 11.5 89.8c3 0 6.3-6.7 7.8-13.3m64.4-85.3c3.5 1.7 5.5 11.3 5.1 14c-.7 5-2.5 10.4-3.8 9.7c-1.5-.6.3-7.4-.4-9.5c-.8-3-5.5-8.4-5-10c-1-3.4 2-4.8 4.1-4.2m-255.7 67.9c3.3 1.3 5.3 8.3 5 10.3c-.8 3.7-2.5 7.7-3.8 7.1c-1.3-.4.3-5.4-.3-7c-.3-3.7-4.9-5.7-4.8-7.3c-.8-3 2-3.5 4-3.1z"
                      />
                      <path
                        fill="#165d31"
                        d="M244.9 218.2c4.2.2 6.3 3.6 2.4 5c-4 1.3-7.7 2.4-7.8 8c1.5 8-2 5.2-4 4.2c-2.4-1.8-9.2-6-10.2-15c-.1-2.1 1.6-4 4.3-4c4 1.1 10 1.2 15.3 1.8"
                      />
                      <path
                        fill="#fff"
                        d="M77.4 124.4c4.8 1.4 5.1 8.6 4.8 10.7c-.7 3.8-2.4 7.9-3.6 7.4c-1.4-.5 0-5.7-.7-7.3c-.7-2.2-4.8-6.4-4.4-7.6c-.9-2.5 2-3.7 3.9-3.2m95.9 33.6c-3.8 2-5.2 8-2.9 11.6c2.2 3 5.6 1.9 6 1.9c3.7.4 5.9-6.9 5.9-6.9s.1-2-4.2 1.9c-1.9.3-2-.4-2.5-1.4a9 9 0 0 1 .5-5.7c.7-1.8-.7-2.6-2.8-1.4m28-36.4c-2 1.3-5.7 5.2-5.8 9.6c-.1 2.5-.6 2.5 1 4c1.3 1.8 2.4 1.7 4.8.4a5.1 5.1 0 0 0 2.3-3.4c.6-2.8-3 1.4-3.4-1.8c-.8-3 1.5-4.2 3.7-7c0-2 0-3.3-2.7-1.8zm22.4 4a59.5 59.5 0 0 0-1.6 11.1c-.6 2.8 3 4 4.5.4c2.4-6.5 2.4-9.3 2.6-12c-.7-4.3-3.6-4.2-5.5.5m142 72.3c.4-.5 20-14.4 20-14.4c2-.7 1.5 7.2.6 7.1a77.8 77.8 0 0 1-20.7 14.3c-1 .7-1.9-5.3 0-7zm17.7-.2c3.5 1.7 4.9 11.8 4.5 14.5c0 5.4-3.3 9.6-4.7 9c-1.4-.7.2-6.7-.5-8.8c-.8-3-3.7-8.5-3.2-10.1c-1-3.4 1.8-5.2 4-4.6zm-116 43.4a26 26 0 0 1 5.6-4.9c2-1 3.8.8 3.7.7c.3 2-1.2 3.7-.7 6.3c.4 1 .7 2.2 2.6 1.8c3.1-2.5 6-2.7 9-2.8c2.5.1 2.6 4.2 1 4.2c-5.7 1.2-8.2 2.8-12.3 4.3c-2 1.2-3.6-.3-3.6-.4s-1.1-1.1-.4-3.7c.2-2-.6-3.2-2.4-3c-1.2.8-2.4 1.2-3-.3c-.3-1-.4-1.6.5-2.2m136.6 5.4c.8 1 1.4 2-.1 3.8l-3.7 3.2c-.6 1-1 2.8 1 3.3c3.6 1 12-4.5 12-4.6c1.4-1 1-3 .8-3c-.8-.9-2.6-.3-3.8-.5c-.6 0-2.5-.2-1.6-2a11.4 11.4 0 0 0 1.6-2.9c.5-1.2 0-2-2-2.7c-2.1-.4-3-.2-5.3 0c-1.2.2-1.6.8-1.9 2.3c.1 2.3 1.5 2.2 3 3z"
                      />
                      <path
                        fill="#165d31"
                        d="M268.1 189.7c-.5 1-2.3 1-4 0s-2.7-2.6-2.1-3.5s2.3-.9 4 0s2.6 2.6 2.1 3.5m-89-53.6c-1 .3-2.4-.6-3-2s-.3-2.6.7-2.9s2.3.7 3 2s.3 2.7-.8 3zM355.2 375c9.4.4 18.2 0 27.5.5c1.7 1.5.5 5-.6 4.8l-7.8-.3c-.1-3-7.7-2.5-7.5.1c-4.1.5-7.8-.1-12-.3c-1.2-1.5-1-4.2.4-4.8"
                      />
                    </g>
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="32px"
                    height="24px"
                    viewBox="0 0 640 480"
                  >
                    <path fill="#bd3d44" d="M0 0h640v480H0" />
                    <path
                      stroke="#fff"
                      stroke-width="37"
                      d="M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"
                    />
                    <path fill="#192f5d" d="M0 0h364.8v258.5H0" />
                    <marker id="flagUs4x30" markerHeight="30" markerWidth="30">
                      <path fill="#fff" d="m14 0l9 27L0 10h28L5 27z" />
                    </marker>
                    <path
                      fill="none"
                      marker-mid="url(#flagUs4x30)"
                      d="m0 0l16 11h61h61h61h61h60L47 37h61h61h60h61L16 63h61h61h61h61h60L47 89h61h61h60h61L16 115h61h61h61h61h60L47 141h61h61h60h61L16 166h61h61h61h61h60L47 192h61h61h60h61L16 218h61h61h61h61h60z"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu bg-light">
                  <li>
                    <button
                      @click="changeLanguage('en')"
                      class="dropdown-item"
                      style="text-align: start"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32px"
                        height="24px"
                        viewBox="0 0 640 480"
                      >
                        <path fill="#bd3d44" d="M0 0h640v480H0" />
                        <path
                          stroke="#fff"
                          stroke-width="37"
                          d="M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"
                        />
                        <path fill="#192f5d" d="M0 0h364.8v258.5H0" />
                        <marker
                          id="flagUs4x30"
                          markerHeight="30"
                          markerWidth="30"
                        >
                          <path fill="#fff" d="m14 0l9 27L0 10h28L5 27z" />
                        </marker>
                        <path
                          fill="none"
                          marker-mid="url(#flagUs4x30)"
                          d="m0 0l16 11h61h61h61h61h60L47 37h61h61h60h61L16 63h61h61h61h61h60L47 89h61h61h60h61L16 115h61h61h61h61h60L47 141h61h61h60h61L16 166h61h61h61h61h60L47 192h61h61h60h61L16 218h61h61h61h61h60z"
                        />
                      </svg>
                      English
                    </button>
                  </li>
                  <li>
                    <button
                      @click="changeLanguage('ar')"
                      class="dropdown-item"
                      style="text-align: start"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32px"
                        height="24px"
                        viewBox="0 0 640 480"
                      >
                        <defs>
                          <clipPath id="flagSa4x30">
                            <path
                              fill-opacity="0.7"
                              d="M-85.3 0h682.6v512H-85.3z"
                            />
                          </clipPath>
                        </defs>
                        <g
                          fill-rule="evenodd"
                          clip-path="url(#flagSa4x30)"
                          transform="translate(80)scale(.9375)"
                        >
                          <path fill="#165d31" d="M-128 0h768v512h-768z" />
                          <path
                            fill="#fff"
                            d="M65.5 145.1c-.8 12-2 33 8.3 35.2c12.3 1.2 5.5-20.8 10-24.8c.8-2 2.3-2 2.4.5v18.7c0 6 4 7.8 7 9c3.2-.2 5.4 0 6.6 3l1.6 32.3s7.4 2.2 7.8-18.1c.3-12-2.4-21.9-.8-24.2c0-2.3 3-2.4 5-1.3c3.2 2.2 4.6 5 9.6 4c7.6-2.2 12.2-5.9 12.3-11.7a47 47 0 0 0-3.5-16.6c.4-1-1.4-3.7-1-4.7c1.3 2.2 3.4 2 3.8 0c-1.3-4.2-3.3-8.3-6.5-10c-2.7-2.4-6.7-2-8 3c-.8 5.7 2 12.4 6.1 18c.9 2.1 2.1 5.7 1.6 8.9c-2.2 1.3-4.4.7-6.3-1.2c0 0-6-4.5-6-5.6c1.6-10.2.3-11.4-.6-14.3c-.6-3.9-2.5-5.2-4-7.8c-1.5-1.6-3.5-1.6-4.5 0c-2.7 4.6-1.4 14.5.5 19c1.4 4.1 3.5 6.7 2.5 6.7c-.8 2.3-2.5 1.7-3.8-1a66.6 66.6 0 0 1-2.1-17.4c-.5-4.6-1.1-14.4-4.2-17c-1.8-2.4-4.5-1.2-5.5 1a82.4 82.4 0 0 0 .3 13.4c2 7.4 2.7 14 3.7 21.5c.3 10.1-5.8 4.4-5.5-.7a45 45 0 0 0-.3-19.4c-1-2.6-2.1-3.2-4.6-2.8c-1.9 0-6.8 5.3-8.2 14.3c0 0-1.2 4.6-1.7 8.7c-.7 4.6-3.7 8-5.9-.6c-1.8-6.3-3-21.6-6-18z"
                          />
                          <path
                            fill="#fff"
                            d="m99 194.2l-32 15.4c.3-7.3 15.1-20.4 25.3-20.5c6.5.1 4.9 2.5 6.6 5.1z"
                          />
                          <path
                            fill="#fff"
                            d="M93.3 204.2c-16.8 43.5 39.5 49.6 45.8 1.8c.6-2 3-3.9 3.4-.7c-1.3 43.3-43.6 46.2-50.8 32.6a41.9 41.9 0 0 1-2.5-14.6c-1-8.5-5.5-5.2-6.2 3.2c-.7 4.7-.5 6-.5 10.5c2.2 34.2 56.7 19.5 65.6-8.7c4.7-15.6-.8-27.1 1.7-27.1c5.4 5.8 13 .8 14.7-1.2c.7-1 2.5-1.7 3.7-.4c4.2 3 11.6 1.6 13.2-3.7c.9-5.3 1.6-10.7 1.8-16.2c-3.5 1-6 1.7-6.3 3.2l-.7 4.6c-.3 1.5-3.2 1.5-3.4-.4c-1.3-6-6.7-6.7-10 2.5c-2.1 1.8-6.1 2.2-6.5-.5c.5-6.2-2-7-7-4.1l-4.8-36.2c2 0 4 1.5 5.9-.9c-2-6.5-6.5-19.7-9-20.7c-1.1-1.4-2.1-.5-3.7-.1c-2.6.8-5 3-4.2 7.4c3 18.8 5 33.1 8.1 52c.5 2.1-1.3 5-3.7 4.7c-4-2.7-5-8.2-12-8c-5 0-10.6 5.5-11.3 10.7c-.9 4.2-1.2 8.7 0 12.3c3.5 4.2 7.7 3.8 11.4 2.9c3-1.3 5.5-4.3 6.6-3.6c.7.9.1 10.9-14.3 18.5c-8.7 4-15.7 4.8-19.4-2.3c-2.3-4.5.2-21.4-5.6-17.5"
                          />
                          <path
                            fill="#fff"
                            d="M165 160c3.3-1.2 19.3-19.6 19.3-19.6l-2.4-2c-.9-.7-.8-1.5 0-2.2c4-2.4 2.7-7.4.7-9.8a9.7 9.7 0 0 0-8.7.1c-2.8 2.7-3.4 7-1.2 9.6c2.1 1 4.2 3.2 2.8 4.4c-6.6 7-24.5 19.1-22.4 19.5c.4.6 11.5.6 11.8 0zm-97 65c-6 9.6-6.5 23.9-3.2 28.2c1.8 2 4.7 2.9 6.8 2.2c3.8-1.6 5.5-9.3 4.6-12c-1.3-2-2.3-2.3-3.6-.7c-2.6 5.4-3.7 1.7-4-1.3a70 70 0 0 1 .8-15.2c.7-4.2 0-3-1.4-1.2m257.1-15.3c-5.8-12.6-13.9-25-16.4-29.7a558 558 0 0 0-24.8-36c-6.2-7.4 10.2 3.1-2-11.7l-8.9-7.5c-2-1.4-6.8-4-7.6.2c-.4 3.8-.2 5.8.4 8.9c.5 2 3.5 5.5 5 7.5a565 565 0 0 1 53.8 86.5c2.6-1.3 2-16.1.5-18.2"
                          />
                          <path
                            fill="#fff"
                            d="M299.6 251.5c-1.2 1.3 2.8 6.8 8 6.8c8.6-1 16.2-5.8 23.2-18.6a33 33 0 0 0 5.3-14.2a317 317 0 0 0-5.8-72.4c-.3-2 0-4.4.2-5c.6-.7 2.5 0 3.5-1.7c1.5-1.5-4-14-7-18.7c-1-2.2-1.5-3.6-3.3.2a27 27 0 0 0-3 13.6c4.1 28.5 5.4 53.4 8 81.9c.3 2.8-.1 6.8-2 8.4a80.2 80.2 0 0 1-27.1 19.7m116.5-.1c-6.2 3.6-6.2 7.7-1.2 7.8c8.6-1 18.8-1.7 25.8-12.3a41 41 0 0 0 4.2-16a303 303 0 0 0-4.7-71.4c-.2-2-1.1-6.7-.8-7.3c.6-1.4 3.4.1 4.4-1.5c1.4-1.5-7.3-12.7-10.4-17.5c-1-2.2-1.4-3.6-3.3.2a22.3 22.3 0 0 0-1.8 13.6c4.6 31 8 54.2 8.7 81.6c-.4 2.6-.5 4-1.7 7.3c-2.7 3.4-5.7 7.8-8.5 9.9c-2.8 2-8.8 4-10.7 5.6"
                          />
                          <path
                            fill="#fff"
                            d="M420.7 223.7c0-7.3.1-13.5-.1-19a34 34 0 0 0-3-13.5c-1.8-4.1-.7-7.4-1.6-11.8c-.8-4.4-.6-11-1.8-16.1c-.4-2-1.4-8.5-1.1-9.2c.5-1.4 2.4 0 3.4-1.6c1.4-1.5-5-18-8.2-22.7c-1.1-2.1-3.3-1.4-5.8 2c-2.5 2.3-1.6 7.4-.6 12.3c6.1 32.3 10.8 61.6 9.8 92.3c-.4 2.6 9-7.8 9-12.7m-45.7-40c-3.9-.2-12-7.7-14.4-12a8 8 0 0 1 .4-6.5c1.5-1 3.7-2 5.4-1c0 0 1.7 2.4 1.4 2.7c2 1 3 .5 3.2-.4c.1-1.5-.6-2.4-.6-4c.9-4.6 6-5.3 8-2.4c1.4 1.8 2 5.5 2.1 8c0 1.3-2-.2-3.3 0c-1.1.4-1.4 1.8-1.5 3c-.2 3.3-.6 8.6-.7 12.5zm-71.8 48c1-9.8-.4-27.3-.5-33.1A477 477 0 0 0 299 154c-1.2-8.4 3.4.9 2.8-4c-1.5-8.3-6.1-14-11.6-21.5c-1.7-2.5-1.7-3-4.4.6c-3 6.7-.4 11.4.4 16.7c3.9 17.2 6.2 33 7.3 48.7a393 393 0 0 1 .4 49c3 .1 7.6-4.7 9.3-11.8"
                          />
                          <path
                            fill="#fff"
                            d="M434 216c-6.9-11.6-17.2-24-20-28.7a658 658 0 0 0-29.2-37.8c-8.5-9 4-1.5-1.6-8.5c-4.7-5.1-6-6.8-10.1-9.9c-2-1.3-3.2-3.8-4 .5a83 83 0 0 0-.2 11.2c0 1.7 1.8 5 3.4 7c20.7 25.5 43.4 51.5 61.6 84.2c2.6-1.3 1.7-16 0-18z"
                          />
                          <path
                            fill="#165d31"
                            d="M122.6 194.7c-.5.9-1.6 2-1.2 3.1c.7 1 1.4 1.3 2.6 1.3c1.1 0 2.7.3 3-.3c.6-.7 1-2 .6-3.3c-1.2-3-4.4-1.8-5-.8"
                          />
                          <path
                            fill="#fff"
                            d="M354.2 362.5c9.2.4 15.2.5 23.3 1.4l9.6-1c10.6-1 11 15.1 11 15.1c0 9.5-3.7 10-8.4 11c-2.7.4-4-1.6-5.5-3.6a14 14 0 0 1-7 .4c-3.9-.2-7.7-.2-11.5-.5c-4-.3-6.2.5-10.3.1c-.8 1.3-2 3.1-4.4 2.6c-2-.3-4.5-6-3.8-10.5c1.5-3.2 1-2.1 1-3.5c-37.6-1-75.5-2.7-112.3-2.2c-28.8.1-57.2 1.3-85.7 2.5c-15.2-.2-26.8-2.6-34.8-14.3c.8 0 38.8 2.1 49.9 1.4c20.5-.2 39.3-1.9 60.2-2.5c41.2.7 82.1.7 123.3 3.6c-4-2.7-4-9 2-10.6c.5-.4.8 3.1 1.7 3c4.9-.3 2.7 6.3 1.7 7.6M188.6 135.3c-6.2 17.8 3.6 37.4 10.4 35.5c5 2 8-7.4 10-17.6c1.5-2.9 2.5-3.2 3.2-1.7c-.2 13.6 1 16.7 4.5 20.8c7.8 6 14.3.8 14.8.3l6-6.1c1.4-1.5 3.2-1.5 5.1-.3c1.9 1.7 1.6 4.6 5.6 6.6c3.4 1.4 10.5.4 12.2-2.5c2.2-3.9 2.8-5.2 3.8-6.6c1.6-2.1 4.3-1.2 4.3-.5c-.3 1.2-1.9 2.3-.8 4.5c2 1.4 2.4.5 3.5.2c4-2 7-10.6 7-10.6c.1-3.2-1.7-3-2.9-2.2l-3.1 2.1c-2 .3-5.7 1.6-7.6-1.3c-1.9-3.4-1.9-8.3-3.3-11.8c0-.2-2.6-5.5-.2-5.8c1.2.2 3.7.9 4.1-1.2c1.2-2.1-2.6-8-5.3-11c-2.3-2.5-5.5-2.8-8.6-.2c-2.2 2-1.9 4.2-2.3 6.3a9.8 9.8 0 0 0 2 8.7c2.2 4.2 6.1 9.7 4.8 17.5c0 0-2.3 3.6-6.3 3.1c-1.7-.3-4.4-1-5.8-11.8c-1.1-8 .2-19.4-3.2-24.7c-1.3-3.3-2.2-6.4-5.2-.9c-.8 2.2-4.3 5.5-1.8 12.2a36 36 0 0 1 2 19c-1.5 2.2-1.8 2.9-3.7 5c-2.6 3-5.5 2.2-7.7 1.1c-2-1.3-3.6-2-4.6-6.5c.2-7 .6-18.5-.7-20.9c-1.9-3.8-5-2.4-6.3-1.2a47.7 47.7 0 0 0-11.5 23.5c-1.8 5.8-3.7 4.1-5 1.8c-3.2-3-3.5-26.7-7.4-22.8"
                          />
                          <path
                            fill="#fff"
                            d="M207.4 174.1c2.9-2 1.6-3.4 5.8.8a72 72 0 0 1 9.2 31.3c-.2 2.6 1.6 4.2 2.5 3.6c.4-6 15.1-14.4 28.6-15.6c2-.5 1-4.4 1.3-6.4c-.8-7.5 4.2-14.3 11.2-14.8c9.6 1.4 12.8 6.5 13 14.2c-1.1 15-16.7 17.5-25.4 18.7c-1.3.5-1.9 1.1 0 1.8l36.6.2l1.9 1c.2 1-.6.2-2 2.6a29.5 29.5 0 0 0-3.7 11.5c-10.9 3.6-22.2 5-33.6 6.5c-4 2-6 4.7-5.2 7.7c1.4 3.3 10.2 6.7 10.2 6.8c1.7 1 3.6 3.5-.5 8.6c-17.8-.8-31.7-8.4-36.5-19.1c-1.4-1.1-3 0-4 1.4c-7 9-13.8 17-25.7 21.4c-7 1.8-14.3-1.1-17.7-5.7c-2.3-2.7-2.2-5.6-3-6.2c-3.9 1.7-36.9 15.7-32.7 9.1c8-8.5 22-14.9 34.2-23.3c.9-2.9 2.5-12.5 7.3-15.6c.3 0-.7 5.6-.6 8c0 2-.2 2.7.2 2.2c.9-.5 15.7-12.2 17-15.8c1.4-2 .3-7.2.3-7.4c-2.8-7.2-6.7-7.8-8.1-11.4c-1.3-4.7-.7-10.1 2-11.7c2.4-2.1 5.2-1.9 7.9.5c3 2.7 5.6 8 6.4 11.9c-.5 1.5-4-1-5-.3a16 16 0 0 1 3.7 7.8c2 8.2 1.4 11.4-.6 16.7c-6.6 13.9-15 18-22.4 23.2c-.2 0-.3 3.5 2.4 5.4c1 1 4.9 1.5 9.4 0a54.5 54.5 0 0 0 22.3-23.3a51 51 0 0 0-2.4-22.2c-2.9-6.7-6.3-16.2-6.3-16.4c-.1-4.2.2-5.6 2-7.7m-95.8-38.6c4.2 2 12.2 1.1 11.8-5.7l-.2-3.1c-.8-2-3.2-1.5-3.7.5c-.2.7.3 1.8-.3 2.1c-.4.4-1.7.2-1.7-1.7c0-.6-.4-1.2-.7-1.6c-.2-.2-.4-.2-.9-.2c-.6 0-.6.1-.9.6c-.1.5-.3 1-.3 1.6c0 .7-.4.9-.8 1c-.6 0-.5 0-1-.2c-.2-.3-.5-.4-.5-1l-.3-1.6c-.2-.3-.6-.5-1-.6c-2.3 0-2.5 2.7-2.3 3.7c-.2.2-.3 4.9 2.8 6.2"
                          />
                          <path
                            fill="#fff"
                            d="M235.1 187.7c4.2 2 14.3.9 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.6c-.2.6.3 1.7-.4 2c-.3.4-1.7.2-1.6-1.6c0-.6-.4-1.3-.7-1.7c-.3-.1-.4-.2-1-.2c-.5 0-.5.2-.8.7c-.2.5-.3 1-.3 1.6c-.1.6-.4.8-.9 1c-.5 0-.4 0-.8-.3c-.3-.3-.6-.4-.6-.9l-.3-1.6c-.2-.3-.6-.5-1-.6c-2.3 0-2.5 2.6-2.4 3.6c-.1.2-.2 5 3 6.2zm72-21.6c4.2 2 12.1 1.1 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.5c-.2.7.3 1.8-.4 2.2c-.3.3-1.7.1-1.6-1.8c0-.6-.4-1.2-.7-1.6c-.3-.2-.4-.2-1-.2c-.5 0-.5.2-.8.7l-.3 1.5c-.1.7-.4 1-.9 1s-.4 0-.8-.2c-.3-.3-.6-.4-.6-.9s-.1-1.3-.3-1.7c-.2-.3-.6-.4-1-.5c-2.3 0-2.5 2.6-2.4 3.6c-.1.2-.2 4.9 3 6.2zm37.3 54.3c-7.3 8.3-4.1 22-2.4 25c2.4 4.8 4.3 7.9 9 10.3c4.3 3.1 7.7 1.2 9.5-1c4.3-4.5 4.4-16 6.4-18.2c1.4-4.2 5-3.5 6.7-1.6a16.5 16.5 0 0 0 6.2 5.3c4 3.5 8.8 4.2 13.6 1c3.2-1.9 5.3-4.2 7.2-8.9c2-5.6 1-31.6.5-47l-4.2-21.5c0-.2-.5-10.2-1-12.5c0-1-.3-1.3.7-1.2c1.1 1 1.2 1 2 1.3c1 .2 2-1.7 1.3-3.3l-10-18.6c-.8-.8-1.9-1.6-3.2.2a7.3 7.3 0 0 0-2.4 5.5c.3 4.4 1 8.9 1.3 13.3l4 22.6c1.3 16 1.6 29.2 2.9 45.3c-.2 6.8-2.3 12.7-4.3 13.6c0 0-3 1.7-5-.2c-1.5-.6-7.4-9.9-7.4-9.9c-3-2.7-5-2-7.1 0c-6 5.8-8.6 16.4-12.7 23.8c-1 1.7-4 3-7.2-.1c-8.2-11.3-3.4-27.3-4.4-23.2M309 126.7c3.8 1.5 6.4 9.2 5.6 13c-.8 4.5-2.8 9.5-4.2 8.9c-1.6-.6 1-4.6-.5-8.8c-.8-2.8-6-7.8-5.4-9.2c-1-3.1 2.2-4.5 4.5-4z"
                          />
                          <path
                            fill="#fff"
                            d="M356.6 225c.7-9.2-.6-14.8-.8-20.2s-6.1-46.6-7.3-50.6c-1.5-7.8 5.7-1 4.9-5.6c-2.5-5.6-8.6-13.9-10.5-18.8c-1.2-2-.7-4-3.3-.5a42.3 42.3 0 0 0-2.3 19.2c6.2 32.3 12.5 59.1 11.5 89.8c3 0 6.3-6.7 7.8-13.3m64.4-85.3c3.5 1.7 5.5 11.3 5.1 14c-.7 5-2.5 10.4-3.8 9.7c-1.5-.6.3-7.4-.4-9.5c-.8-3-5.5-8.4-5-10c-1-3.4 2-4.8 4.1-4.2m-255.7 67.9c3.3 1.3 5.3 8.3 5 10.3c-.8 3.7-2.5 7.7-3.8 7.1c-1.3-.4.3-5.4-.3-7c-.3-3.7-4.9-5.7-4.8-7.3c-.8-3 2-3.5 4-3.1z"
                          />
                          <path
                            fill="#165d31"
                            d="M244.9 218.2c4.2.2 6.3 3.6 2.4 5c-4 1.3-7.7 2.4-7.8 8c1.5 8-2 5.2-4 4.2c-2.4-1.8-9.2-6-10.2-15c-.1-2.1 1.6-4 4.3-4c4 1.1 10 1.2 15.3 1.8"
                          />
                          <path
                            fill="#fff"
                            d="M77.4 124.4c4.8 1.4 5.1 8.6 4.8 10.7c-.7 3.8-2.4 7.9-3.6 7.4c-1.4-.5 0-5.7-.7-7.3c-.7-2.2-4.8-6.4-4.4-7.6c-.9-2.5 2-3.7 3.9-3.2m95.9 33.6c-3.8 2-5.2 8-2.9 11.6c2.2 3 5.6 1.9 6 1.9c3.7.4 5.9-6.9 5.9-6.9s.1-2-4.2 1.9c-1.9.3-2-.4-2.5-1.4a9 9 0 0 1 .5-5.7c.7-1.8-.7-2.6-2.8-1.4m28-36.4c-2 1.3-5.7 5.2-5.8 9.6c-.1 2.5-.6 2.5 1 4c1.3 1.8 2.4 1.7 4.8.4a5.1 5.1 0 0 0 2.3-3.4c.6-2.8-3 1.4-3.4-1.8c-.8-3 1.5-4.2 3.7-7c0-2 0-3.3-2.7-1.8zm22.4 4a59.5 59.5 0 0 0-1.6 11.1c-.6 2.8 3 4 4.5.4c2.4-6.5 2.4-9.3 2.6-12c-.7-4.3-3.6-4.2-5.5.5m142 72.3c.4-.5 20-14.4 20-14.4c2-.7 1.5 7.2.6 7.1a77.8 77.8 0 0 1-20.7 14.3c-1 .7-1.9-5.3 0-7zm17.7-.2c3.5 1.7 4.9 11.8 4.5 14.5c0 5.4-3.3 9.6-4.7 9c-1.4-.7.2-6.7-.5-8.8c-.8-3-3.7-8.5-3.2-10.1c-1-3.4 1.8-5.2 4-4.6zm-116 43.4a26 26 0 0 1 5.6-4.9c2-1 3.8.8 3.7.7c.3 2-1.2 3.7-.7 6.3c.4 1 .7 2.2 2.6 1.8c3.1-2.5 6-2.7 9-2.8c2.5.1 2.6 4.2 1 4.2c-5.7 1.2-8.2 2.8-12.3 4.3c-2 1.2-3.6-.3-3.6-.4s-1.1-1.1-.4-3.7c.2-2-.6-3.2-2.4-3c-1.2.8-2.4 1.2-3-.3c-.3-1-.4-1.6.5-2.2m136.6 5.4c.8 1 1.4 2-.1 3.8l-3.7 3.2c-.6 1-1 2.8 1 3.3c3.6 1 12-4.5 12-4.6c1.4-1 1-3 .8-3c-.8-.9-2.6-.3-3.8-.5c-.6 0-2.5-.2-1.6-2a11.4 11.4 0 0 0 1.6-2.9c.5-1.2 0-2-2-2.7c-2.1-.4-3-.2-5.3 0c-1.2.2-1.6.8-1.9 2.3c.1 2.3 1.5 2.2 3 3z"
                          />
                          <path
                            fill="#165d31"
                            d="M268.1 189.7c-.5 1-2.3 1-4 0s-2.7-2.6-2.1-3.5s2.3-.9 4 0s2.6 2.6 2.1 3.5m-89-53.6c-1 .3-2.4-.6-3-2s-.3-2.6.7-2.9s2.3.7 3 2s.3 2.7-.8 3zM355.2 375c9.4.4 18.2 0 27.5.5c1.7 1.5.5 5-.6 4.8l-7.8-.3c-.1-3-7.7-2.5-7.5.1c-4.1.5-7.8-.1-12-.3c-1.2-1.5-1-4.2.4-4.8"
                          />
                        </g>
                      </svg>
                      عربي
                    </button>
                  </li>
                </ul>
              </div>
              <form>
                <router-link
                  class="nav-item"
                  to="/admin-home"
                  v-if="$store.state.role == 'admin'"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 24 24"
                  >
                    <g fill="white" fill-rule="evenodd" clip-rule="evenodd">
                      <path
                        d="M16 9a4 4 0 1 1-8 0a4 4 0 0 1 8 0m-2 0a2 2 0 1 1-4 0a2 2 0 0 1 4 0"
                      />
                      <path
                        d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1M3 12c0 2.09.713 4.014 1.908 5.542A8.99 8.99 0 0 1 12.065 14a8.98 8.98 0 0 1 7.092 3.458A9 9 0 1 0 3 12m9 9a8.96 8.96 0 0 1-5.672-2.012A6.99 6.99 0 0 1 12.065 16a6.99 6.99 0 0 1 5.689 2.92A8.96 8.96 0 0 1 12 21"
                      />
                    </g>
                  </svg>
                </router-link>
                <router-link
                  class="nav-item"
                  to="/login"
                  v-if="$store.state.token == ''"
                  >{{ $t("Navbar.Login") }}</router-link
                >
                <router-link
                  class="nav-item"
                  to="/"
                  v-if="$store.state.role == 'user'"
                  @click="Logout()"
                  >{{ $t("LogOut") }}</router-link
                >
              </form>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <router-view />
    <footer>
      <div class="footer-containe">
        <div class="footer-logo">
          <img :src="logo_src" style="background-color: whitesmoke" alt="" />
        </div>
        <div class="footer-item">
          <div class="footer-title">{{ $t("ASOOL") + " " + $t("PLUS") }}</div>
          <div class="footer-content footer-content-link">
            <svg
              :class="$i18n.locale === 'ar' ? 'ms-1' : 'me-1'"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7"
              />
            </svg>
            <span class="me-2">King Abdul Aziz University, Jeddah</span>
          </div>
          <div class="footer-content footer-content-link">
            <svg
              :class="$i18n.locale === 'ar' ? 'ms-1' : 'me-1'"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 4l-8 5l-8-5V6l8 5l8-5z"
              />
            </svg>
            <a href="mailto:info@1asool.net" class="footer-link me-2"
              >info@1asool.net</a
            >
          </div>
          <div class="footer-content footer-content-link">
            <svg
              :class="$i18n.locale === 'ar' ? 'ms-1' : 'me-1'"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z"
              />
            </svg>
            <a href="tel:+966 12 597 7077" class="footer-link me-2" dir="ltr"
              >+966 12 597 7077</a
            >
          </div>
          <div class="footer-content footer-content-link">
            <svg
              :class="$i18n.locale === 'ar' ? 'ms-1' : 'me-1'"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48M160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32m112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12z"
              />
            </svg>
            <a href="tel:+966 53 465 9509" class="footer-link me-2" dir="ltr"
              >+966 53 465 9509</a
            >
          </div>
        </div>
        <div class="footer-item">
          <div class="footer-title">{{ $t("UsefulLinks") }}</div>
          <div class="footer-content footer-content-link">
            <router-link to="/" class="footer-link">{{
              $t("Navbar.Home")
            }}</router-link>
          </div>
          <div class="footer-content footer-content-link">
            <router-link to="/projects" class="footer-link">
              {{ $t("Navbar.Projects") }}
            </router-link>
          </div>
          <div class="footer-content footer-content-link">
            <router-link to="/news" class="footer-link">{{
              $t("Navbar.News")
            }}</router-link>
          </div>
        </div>
        <div class="footer-item">
          <div class="footer-title">{{ $t("SocialMedia.SocialMedia") }}</div>
          <div class="footer-content footer-content-link">
            <a
              href="https://www.tiktok.com/@asool_plus?is_from_webapp=1&sender_device=pc"
              target="_blank"
              class="footer-link flex-center"
              style="justify-content: start"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21.19"
                height="24"
                viewBox="0 0 256 290"
              >
                <path
                  fill="#ff004f"
                  d="M189.72 104.421c18.678 13.345 41.56 21.197 66.273 21.197v-47.53a67 67 0 0 1-13.918-1.456v37.413c-24.711 0-47.59-7.851-66.272-21.195v96.996c0 48.523-39.356 87.855-87.9 87.855c-18.113 0-34.949-5.473-48.934-14.86c15.962 16.313 38.222 26.432 62.848 26.432c48.548 0 87.905-39.332 87.905-87.857v-96.995zm17.17-47.952c-9.546-10.423-15.814-23.893-17.17-38.785v-6.113h-13.189c3.32 18.927 14.644 35.097 30.358 44.898M69.673 225.607a40 40 0 0 1-8.203-24.33c0-22.192 18.001-40.186 40.21-40.186a40.3 40.3 0 0 1 12.197 1.883v-48.593c-4.61-.631-9.262-.9-13.912-.801v37.822a40.3 40.3 0 0 0-12.203-1.882c-22.208 0-40.208 17.992-40.208 40.187c0 15.694 8.997 29.281 22.119 35.9"
                />
                <path
                  d="M175.803 92.849c18.683 13.344 41.56 21.195 66.272 21.195V76.631c-13.794-2.937-26.005-10.141-35.186-20.162c-15.715-9.802-27.038-25.972-30.358-44.898h-34.643v189.843c-.079 22.132-18.049 40.052-40.21 40.052c-13.058 0-24.66-6.221-32.007-15.86c-13.12-6.618-22.118-20.206-22.118-35.898c0-22.193 18-40.187 40.208-40.187c4.255 0 8.356.662 12.203 1.882v-37.822c-47.692.985-86.047 39.933-86.047 87.834c0 23.912 9.551 45.589 25.053 61.428c13.985 9.385 30.82 14.86 48.934 14.86c48.545 0 87.9-39.335 87.9-87.857z"
                />
                <path
                  fill="#00f2ea"
                  d="M242.075 76.63V66.516a66.3 66.3 0 0 1-35.186-10.047a66.47 66.47 0 0 0 35.186 20.163M176.53 11.57a68 68 0 0 1-.728-5.457V0h-47.834v189.845c-.076 22.13-18.046 40.05-40.208 40.05a40.06 40.06 0 0 1-18.09-4.287c7.347 9.637 18.949 15.857 32.007 15.857c22.16 0 40.132-17.918 40.21-40.05V11.571zM99.966 113.58v-10.769a89 89 0 0 0-12.061-.818C39.355 101.993 0 141.327 0 189.845c0 30.419 15.467 57.227 38.971 72.996c-15.502-15.838-25.053-37.516-25.053-61.427c0-47.9 38.354-86.848 86.048-87.833"
                />
              </svg>
              <span class="mx-2">@asool_plus</span>
            </a>
          </div>
          <div class="footer-content footer-content-link">
            <a
              href="https://www.instagram.com/asool_plus/?utm_source=ig_web_button_share_sheet"
              target="_blank"
              class="footer-link flex-center"
              style="justify-content: start"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 256 256"
              >
                <g fill="none">
                  <rect
                    width="256"
                    height="256"
                    fill="url(#skillIconsInstagram0)"
                    rx="60"
                  />
                  <rect
                    width="256"
                    height="256"
                    fill="url(#skillIconsInstagram1)"
                    rx="60"
                  />
                  <path
                    fill="#fff"
                    d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396c0 26.688-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413c0-26.704.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5c3.5-3.5 6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355c0 28.361 22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334c-18.41 0-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334"
                  />
                  <defs>
                    <radialGradient
                      id="skillIconsInstagram0"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#fd5" />
                      <stop offset=".1" stop-color="#fd5" />
                      <stop offset=".5" stop-color="#ff543e" />
                      <stop offset="1" stop-color="#c837ab" />
                    </radialGradient>
                    <radialGradient
                      id="skillIconsInstagram1"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#3771c8" />
                      <stop offset=".128" stop-color="#3771c8" />
                      <stop offset="1" stop-color="#60f" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </g>
              </svg>
              <span class="mx-2">asool_plus</span>
            </a>
          </div>
          <div class="footer-content footer-content-link">
            <a
              href="https://x.com/Asool_plus?t=79ImyehbywBemNRyWDfjRw&s=08"
              target="_blank"
              class="footer-link flex-center"
              style="justify-content: start"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="24"
                viewBox="0 0 448 512"
              >
                <path
                  fill="black"
                  d="M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm297.1 84L257.3 234.6L379.4 396h-95.6L209 298.1L123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5l78.2-89.5zm-37.8 251.6L153.4 142.9h-28.3l171.8 224.7h26.3z"
                />
              </svg>
              <span class="mx-2">@Asool_plus</span>
            </a>
          </div>
          <div class="footer-content footer-content-link">
            <a
              href="https://www.snapchat.com/add/asool_plus?share_id=3ALDsv4o5zU&locale=en-US"
              target="_blank"
              class="footer-link flex-center"
              style="justify-content: start"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#fffc00"
                  d="M21.74 5.457a3.4 3.4 0 0 0 0-.55A3.09 3.09 0 0 0 18.6 2.25H5.42q-.46.011-.906.128a3.08 3.08 0 0 0-2.264 3.06v13.075q-.005.403.079.797a3.1 3.1 0 0 0 3.14 2.44H18.53a3.4 3.4 0 0 0 1.142-.187a3.03 3.03 0 0 0 2.067-2.951c.01-4.418 0-8.786 0-13.155m-3.326 10.914c-.314.18-.536.24-.877.361a.46.46 0 0 0-.315.276a1.07 1.07 0 0 1-.984.708l-.817.05a2.84 2.84 0 0 0-1.24.491a3.84 3.84 0 0 1-3.672.305a3 3 0 0 1-.64-.344a2.95 2.95 0 0 0-1.693-.492a2.5 2.5 0 0 1-.542-.05a.99.99 0 0 1-.777-.648a.44.44 0 0 0-.345-.305a2.6 2.6 0 0 1-1.142-.581a.876.876 0 0 1 .197-1.505c.355-.207.709-.404 1.044-.64c.41-.297.747-.684.984-1.131c.148-.295.138-.325-.128-.502a8 8 0 0 1-.807-.59a1.17 1.17 0 0 1-.364-1.28a1.22 1.22 0 0 1 1.437-.855h.187a4.11 4.11 0 0 1 1.26-3.542a4.2 4.2 0 0 1 2.815-.984a4.17 4.17 0 0 1 3.18 1.318a4.3 4.3 0 0 1 .984 3.267q.335-.03.67 0a1.14 1.14 0 0 1 .984.866a1.2 1.2 0 0 1-.374 1.25a9 9 0 0 1-.847.629c-.226.147-.236.177-.118.423a3.9 3.9 0 0 0 1.585 1.574l.433.236a.905.905 0 0 1 .03 1.633z"
                />
                <path
                  fill="#ffffff"
                  d="M17.832 15.316c0 .068-.098.167-.177.196c-.315.128-.63.256-.984.355a.54.54 0 0 0-.463.521a.296.296 0 0 1-.315.295l-.984.069c-.503.084-.98.279-1.398.57a2.9 2.9 0 0 1-3.258-.058a3.6 3.6 0 0 0-1.969-.561h-.05c-.383 0-.432-.06-.491-.433a.38.38 0 0 0-.256-.335c-.168-.068-.335-.108-.502-.177c-.168-.068-.433-.157-.64-.255c-.207-.099-.187-.119-.187-.197s.098-.148.177-.187a5.2 5.2 0 0 0 1.723-1.309c.3-.36.52-.779.65-1.23a.42.42 0 0 0-.168-.53c-.266-.178-.541-.355-.797-.542a2.4 2.4 0 0 1-.374-.325a.4.4 0 0 1 0-.462a.354.354 0 0 1 .393-.187q.305.064.6.157l.13.03l.133.056c.276.099.27-.036.26-.322a14 14 0 0 1 0-1.918a2.68 2.68 0 0 1 1.88-2.214a3.45 3.45 0 0 1 2.598.069a2.765 2.765 0 0 1 1.782 2.656v1.575c0 .255.05.285.276.206l.669-.226a.7.7 0 0 1 .256 0a.39.39 0 0 1 .374.197a.364.364 0 0 1 0 .442a2.3 2.3 0 0 1-.364.335c-.227.157-.463.295-.7.453c-.235.157-.373.344-.245.728a3.6 3.6 0 0 0 1.27 1.77c.315.246.506.347.862.59c.151.102.3.129.29.198"
                />
              </svg>
              <span class="mx-2">Asool_plus</span>
            </a>
          </div>
        </div>
        <!-- <div class="footer-item">
          <div class="footer-content footer-content-link mt-4">
            <router-link to="/make-appointment" class="footer-link login-btn">
              {{ $t("Navbar.ContactUs") }}
            </router-link>
          </div>
        </div> -->
      </div>
    </footer>
    <div class="loader" id="loader"></div>
  </div>
</template>

<script>
import store from "@/store";
import router from "./router";
export default {
  data() {
    return {
      section_index: 0,
      old_key: null,
      logo_src: require("@/assets/Logo/osoolLogo1.png"),
      BackVideo: "",
    };
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      window.localStorage.setItem("lang", lang);
    },
    Logout() {
      store.state.token = "";
      store.state.role = "";
      window.sessionStorage.removeItem("token");
      window.sessionStorage.removeItem("role");
      router.push("/");
    },
  },
  watch: {
    $route(to, from) {
      if (to.path == "/our-team" && from.path == "/our-team") {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const id = urlParams.get("id");
        const element = document.getElementById(id);
        // Scroll to the element
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        const element = document.getElementById("scroll_to");
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  mounted() {
    this.$i18n.locale =
      window.localStorage.getItem("lang") == null
        ? "ar"
        : window.localStorage.getItem("lang");
    if (window.sessionStorage.getItem("token") !== null) {
      const token = window.sessionStorage.getItem("token");
      store.state.token = token;
    }
    if (window.sessionStorage.getItem("role") !== null) {
      const role = window.sessionStorage.getItem("role");
      store.state.role = role;
    }
  },
};
</script>

<style lang="scss">
/* Importing Fonts */
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&family=Fustat:wght@200..800&display=swap");

/* Global Styles */
body {
  overflow-y: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #072d2a;
  margin-top: 70px;
  background-color: rgba(25, 25, 25, 0.6);
  font-family: "Cairo", sans-serif;
  overflow-x: hidden;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* Navigation Styles */
nav {
  padding: 20px;
  background-color: #d3b37d;
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 10;
  font-size: 16px;
  font-weight: 600;
  .nav-item {
    a {
      font-weight: bold;
      color: whitesmoke;
      text-decoration: none;
      width: max-content;
      &.router-link-exact-active {
        text-decoration: none;
        color: #072d2a;
      }
    }
  }
  a {
    font-weight: bold;
    color: whitesmoke;
    text-decoration: none;

    &.router-link-exact-active {
      text-decoration: none;
      color: #072d2a;
    }
  }
}

.nav-item {
  margin: 0 10px 0 10px;
  color: whitesmoke;
  cursor: pointer;
  transition: 0.5s ease-in-out;
  width: fit-content;
}

.nav-item > .nav-link {
  color: whitesmoke;
}

.nav-item > img {
  height: 70px;
  width: auto; /* Ensures the image maintains its aspect ratio */
  max-width: 100%; /* Prevents it from exceeding its natural size */
  border-radius: 30%;
}

.nav-item:hover {
  transform: translateY(-5px);
}

.nav-item:hover > .nav-link {
  color: #072d2a;
}

.nav-btn {
  background-color: unset;
  color: whitesmoke;
  border: none;
  padding: 0;
  margin: 0;
}

.right-side,
.left-side {
  display: flex;
  align-items: center;
  width: 100%;
}

.left-side {
  justify-content: end;
}

/* Dropdown Titles */
.drop-title {
  color: #191919;
  font-size: 24px;
  font-weight: 700;
  transition: 0.5s ease-in-out;
}

.drop-title:hover {
  color: #c39a3e;
}

/* Grid Layout */
.myrow {
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(300px, 1fr)
  ); /* Responsive grid */
  gap: 10px;
  width: 100%;
  text-align: start;
}

.mycol {
  margin: 10px 0 20px 0;
}

/* Category and Subtitle Styling */
.cat-title {
  font-weight: 700;
  color: #191919;
  text-decoration: none;
  transition: 0.5s ease-in-out;
}

.cat-title:hover {
  color: #c39a3e;
}

.sub-title {
  color: #7e7e7e;
  text-decoration: none;
  transition: 0.5s ease-in-out;
}

.sub-title:hover {
  color: #c39a3e;
}

/* Search Bar */
.search-bar {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
}

.my-inp {
  border-radius: 10px;
  border: none;
  font-size: 18px;
  padding: 5px 10px;
}

.my-inp:focus {
  outline: none !important;
}

.my-svg {
  color: #7e7e7e;
  position: absolute;
  z-index: 11;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  cursor: pointer;
}

/* Footer Styling */
.footer-containe {
  background-color: #d3b37d;
  padding: 20px;
  display: grid;
  grid-template-columns: 10% 30% 30% 30%;
  justify-content: start;
  align-items: start;
  width: 100%;
}

.footer-logo {
  margin: 0 50px;
  text-align: start;
  width: 100%;
}

.footer-logo > img {
  height: 100px;
  width: auto;
  border-radius: 10px;
}

.footer-item {
  margin: 0 50px;
  text-align: start;
  width: 100%;
}

.footer-title {
  color: #072d2a;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 10px 0;
}

.footer-content {
  color: whitesmoke;
  font-weight: 700;
  font-size: 20px;
  transition: 0.5s ease-in-out;
}

.footer-content-link:hover {
  transform: translateX(-10px);
  text-decoration: underline;
}

.footer-link {
  color: whitesmoke;
  text-decoration: none;
}

/* Buttons */
.login-btn {
  background-color: whitesmoke;
  color: #072d2a;
  padding: 10px;
  border-radius: 10px;
  transition: 0.5s ease-in-out;
}

.login-btn:hover {
  box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
}

/* Background and Loader */
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("assets/Portfilio/BackGround/1.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.bg-whitesmoke {
  background-color: rgba(245, 245, 245, 0.7);
}

.loader {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000000;
  background-image: url(assets/loader.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  filter: grayscale(100%);
  animation: loaderAnimate 3s infinite;
}

@keyframes loaderAnimate {
  0% {
    filter: grayscale(100%);
  }
  50% {
    filter: grayscale(50%);
  }
  100% {
    filter: grayscale(100%);
  }
}

/* Media Queries */
@media screen and (max-width: 1023px) {
  .flex-center,
  .right-side,
  .left-side {
    display: block;
  }
}

@media screen and (max-width: 1025px) {
  .footer-containe {
    display: flex;
    flex-direction: column;
  }
}

/* Animation for Fade-out */
.fade-out {
  animation: fadeOutAnimation 2s ease-out forwards;
}

@keyframes fadeOutAnimation {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-60px);
  }
}

/* Animation for Fade */
.fade {
  animation: fadeAnimation 2s ease-out forwards;
}

@keyframes fadeAnimation {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
